import Blocked from './variation/blocked';
import Default from './variation/default';
import Question from './variation/question';
import Refresh from './variation/refresh';
import Secondary from './variation/secondary';
import Selected from './variation/selected';
import Third from './variation/third';

type DefaultType = typeof Default;
type SecondaryType = typeof Secondary;
type ThirdType = typeof Third;
type BlockedType = typeof Blocked;
type QuestionType = typeof Question;
type RefreshType = typeof Refresh;
type SelectedType = typeof Selected;

interface CompoundedComponent extends DefaultType {
  Secondary: SecondaryType;
  Third: ThirdType;
  Blocked: BlockedType;
  Question: QuestionType;
  Refresh: RefreshType;
  Selected: SelectedType;
}

const UserIcon = Default as CompoundedComponent;
UserIcon.Secondary = Secondary;
UserIcon.Third = Third;
UserIcon.Blocked = Blocked;
UserIcon.Question = Question;
UserIcon.Refresh = Refresh;
UserIcon.Selected = Selected;

export default UserIcon;
